module.exports = __webpack_public_path__ + "img/school-banner.6273bd98.png";